import React from 'react';
import _get from 'lodash/get';
import _classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import Badge from 'components/Badge';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    padding: 20,
    marginTop: theme.spacing(2),
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 8,
  },
  badgeRoot: {
    position: 'absolute',
    top: 0,
    left: '50%',
    display: 'flex',
    alignItems: 'center',
    padding: '0px 4px',
    background: '#fff',
    transform: 'translate(-50%, -50%)',
  },
  badgeContainer: {
    height: 'auto',
    margin: 0,
    '& span': {
      color: 'inherit',
      paddingTop: 0,
      marginLeft: 8,
      fontSize: 'inherit',
    },
  },
}));

export const CourseRecommendedPaper = ({ className, item, children }) => {
  const classes = useStyles();
  const type = _get(item.sys, 'contentType.sys.id');

  return (
    <div aria-label={type} className={_classNames(classes.root, className)}>
      <Badge customClasses={classes} type={type} />
      {children}
    </div>
  );
};
